export enum TableOfContentNodeType {
  Organisation = 1,
  Taxonomy = 2,
}
